import React, { useState } from "react";
import { Link } from "react-router-dom";
import { CalendarClock, HardHat } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { fmtDate } from "./SavFields";

function Card({ s, onDragStart }) {
  return (
    <div draggable onDragStart={(e) => { e.dataTransfer.setData("text/plain", s.id); onDragStart(s.id); }}
      className="bg-white border border-norea-border rounded-md p-2.5 cursor-grab active:cursor-grabbing hover:border-norea-primary/50 transition-colors shadow-sm" data-testid={`kanban-card-${s.id}`}>
      <div className="flex items-center justify-between gap-2">
        <Link to={`/sav/${s.id}`} className="font-mono text-[10px] text-norea-primary hover:underline whitespace-nowrap">{s.reference}</Link>
        <span className={`text-[10px] truncate ${s.kind === "desinstallation" ? "text-norea-primary font-semibold" : "text-norea-textMuted"}`}>{s.values?.type_sav}</span>
      </div>
      <div className="text-sm font-medium mt-1 truncate">{[s.client?.prenom, s.client?.nom].filter(Boolean).join(" ")}</div>
      <div className="text-[11px] text-norea-textMuted truncate">{s.values?.probleme_materiel || "—"} · {s.client?.ville}</div>
      <div className="flex items-center gap-3 mt-1.5 text-[10px] text-norea-textMuted">
        <span className="inline-flex items-center gap-1"><HardHat className="w-3 h-3" />{s.subcontractor_name || "—"}</span>
        {s.values?.date_rdv && <span className="inline-flex items-center gap-1"><CalendarClock className="w-3 h-3" />{fmtDate(s.values.date_rdv)}</span>}
        {(s.relances?.count ?? 0) > 0 && <span className="text-amber-700">Relance {s.relances.count}</span>}
      </div>
    </div>
  );
}

export default function SavKanban({ items, statuses, onMoved }) {
  const [over, setOver] = useState(null);
  const [dragId, setDragId] = useState(null);
  const drop = async (status) => {
    setOver(null);
    const s = items.find((x) => x.id === dragId);
    if (!s || s.status === status) return;
    try { await api.post(`/sav/${s.id}/status`, { status }); toast.success(`${s.reference} → ${statuses.find((x) => x.id === status)?.label}`); onMoved(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Changement impossible"); }
  };
  return (
    <div className="flex gap-2 overflow-x-auto pb-3" data-testid="sav-kanban">
      {statuses.map((st) => {
        const col = items.filter((s) => s.status === st.id);
        return (
          <div key={st.id} onDragOver={(e) => { e.preventDefault(); setOver(st.id); }} onDragLeave={() => setOver(null)} onDrop={(e) => { e.preventDefault(); drop(st.id); }}
            className={`flex-1 min-w-[150px] rounded-md border p-2 transition-colors ${over === st.id ? "border-norea-primary bg-norea-primary/5" : "border-norea-border bg-norea-bg/50"}`} data-testid={`kanban-col-${st.id}`}>
            <div className="flex items-center justify-between px-1 mb-2 text-xs font-semibold text-norea-text">{st.label}<span className="text-norea-textMuted font-normal" data-testid={`kanban-count-${st.id}`}>{col.length}</span></div>
            <div className="space-y-2 min-h-[60px]">{col.map((s) => <Card key={s.id} s={s} onDragStart={setDragId} />)}</div>
          </div>
        );
      })}
    </div>
  );
}
